import { LinkIcon, MarkGithubIcon } from "@primer/octicons-react";
import { Link } from "react-router-dom";
import { useAction, useRepoConnection } from "../api/hooks";
import { ErrorMessage, TimeAgo } from "./common";
import { Alert, AlertTitle } from "./ui/alert";
import { Button } from "./ui/button";
import { ConfirmDialog } from "./ui/confirm-dialog";

/** Whose GitHub connection the bridge uses for this repo's import and remote sync; nothing when none. */
export function RepoConnection({ repo, admin }: { repo: string; admin: boolean }) {
  const q = useRepoConnection(repo);
  const unbind = useAction(repo);
  const c = q.data;
  if (!c) return null;
  const Icon = MarkGithubIcon;
  const ok = c.status === "ok";
  return (
    <Alert variant={ok ? "info" : "error"} className="mt-0">
      <AlertTitle>
        <LinkIcon /> {ok ? "Uses a connected account" : "The connected account no longer works"}
      </AlertTitle>
      <div className="flex flex-wrap items-center gap-x-2 gap-y-1">
        <span>
          bee authenticates to {c.host} as <Icon /> <b>{c.login}</b>, bound by {c.bound_by} <TimeAgo ms={c.created} />.{" "}
          {c.status === "revoked" && (
            <>
              GitHub refused its token: {c.login} must reconnect it from <Link to="/profile?tab=account">Account</Link>, or remove
              the binding.
            </>
          )}
          {c.status === "disconnected" && <>Its owner disconnected it.</>}
        </span>
        {admin && (
          <ConfirmDialog
            title="Remove the binding?"
            description="bee uses its environment token for this repository instead."
            confirmLabel="Remove binding"
            onConfirm={() => unbind.mutate({ method: "DELETE", path: `/v1/repos/${repo}/connection`, body: {} })}
          >
            <Button type="button" size="sm" disabled={unbind.isPending}>
              Remove binding
            </Button>
          </ConfirmDialog>
        )}
      </div>
      {unbind.error ? <ErrorMessage error={unbind.error} /> : null}
    </Alert>
  );
}
